export const SOURCE_COLOR_MAP: Record<string, string> = {
  facebook_ads: '#1E40AF',
  instagram_ads: '#E4405F',
  whatsapp: '#059669',
  whatsapp_ads: '#10B981',
  google_ads: '#06B6D4',
  linkedin_ads: '#0A66C2',
  youtube_ads: '#EF4444',
  website: '#D946EF',
  broadcast: '#EA580C',
  organic_social: '#F59E0B',
  referral: '#8B5CF6',
  direct: '#3B82F6',
  shopify: '#96BF48',
  other: '#94A3B8',
  unknown: '#CBD5E1',
}
